export const seatrc2026Schedule = [
  {
    date: "2026-07-24",
    time: "07:00-08:00",
    activity: "Check-in & Accreditation (SEATRC)",
    location: "TNGGP Hall",
    categories: ["all"],
  },
  {
    date: "2026-07-24",
    time: "08:00-10:00",
    activity: "Opening Ceremony & Nation Parade",
    location: "TNGGP Hall",
    categories: ["all"],
  },
  {
    date: "2026-07-24",
    time: "10:00-11:30",
    activity: "Technical Meeting",
    location: "TNGGP Hall",
    categories: ["all"],
  },
  {
    date: "2026-07-24",
    time: "14:00-14:30",
    activity: "Call Room Open & Close Vertical Category",
    location: "Cibodas",
    categories: ["uphill"],
  },
  {
    date: "2026-07-24",
    time: "15:00",
    activity: "Flag Off Uphill Vertical 7K (SEATRC)",
    location: "Cibodas",
    categories: ["uphill"],
  },
  {
    date: "2026-07-24",
    time: "15:00-16:00",
    activity: "Press Conference",
    location: "TBC",
    categories: ["all"],
  },
  {
    date: "2026-07-24",
    time: "17:00",
    activity: "Cut Off Time Uphill Vertical 7K",
    location: "Kd Badak",
    categories: ["uphill"],
  },
  {
    date: "2026-07-25",
    time: "00:01-00:30",
    activity: "Call Room Open & Close Long Trail",
    location: "Cibodas",
    categories: ["75"],
  },
  {
    date: "2026-07-25",
    time: "01:00",
    activity: "Flag Off Long Trail 75K (SEATRC)",
    location: "Cibodas",
    categories: ["75"],
  },
  {
    date: "2026-07-25",
    time: "03:00-03:30",
    activity: "Call Room Open & Close Short Trail",
    location: "Cibodas",
    categories: ["42"],
  },
  {
    date: "2026-07-25",
    time: "04:00",
    activity: "Flag Off Short Trail 42K (SEATRC)",
    location: "Cibodas",
    categories: ["42"],
  },
  {
    date: "2026-07-25",
    time: "10:00",
    activity: "COP Long Trail & Short Trail (SEATRC)",
    location: "Selabintana",
    categories: ["75", "42"],
  },
  {
    date: "2026-07-25",
    time: "14:00",
    activity: "Cut Off Time Short Trail 42K (SEATRC)",
    location: "Cibodas",
    categories: ["42"],
  },
  {
    date: "2026-07-25",
    time: "19:00",
    activity: "Cut Off Time Long Trail 75K (SEATRC)",
    location: "Cibodas",
    categories: ["75"],
  },
  {
    date: "2026-07-26",
    time: "05:00-05:30",
    activity: "Call Room Open & Close Mountain Classic (SEATRC)",
    location: "Cibodas",
    categories: ["10"],
  },
  {
    date: "2026-07-26",
    time: "06:00",
    activity: "Flag Off Mountain Classic 10K - Male",
    location: "Cibodas",
    categories: ["10"],
  },
  {
    date: "2026-07-26",
    time: "06:10",
    activity: "Flag Off Mountain Classic 10K - Female",
    location: "Cibodas",
    categories: ["10"],
  },
  {
    date: "2026-07-26",
    time: "08:00",
    activity: "Cut Off Time Mountain Classic 10K - Male",
    location: "Cibodas",
    categories: ["10"],
  },
  {
    date: "2026-07-26",
    time: "08:10",
    activity: "Cut Off Time Mountain Classic 10K - Female",
    location: "Cibodas",
    categories: ["10"],
  },
  {
    date: "2026-07-26",
    time: "09:00",
    activity: "Closing Ceremony and Award SEATRC",
    location: "Cibodas",
    categories: ["all"],
  },
];

export const formatScheduleDate = (date) =>
  new Date(`${date}T00:00:00`).toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });

const resolveCategoryKey = (categoryName = "") => {
  const category = categoryName.toLowerCase();

  if (category.includes("uphill") || category.includes("vertical")) return "uphill";
  if (category.includes("75") || category.includes("long trail")) return "75";
  if (category.includes("42") || category.includes("short trail")) return "42";
  if (category.includes("10") || category.includes("classic")) return "10";
  return "";
};

export const getSeatrcCategorySchedule = (categoryName) => {
  const categoryKey = resolveCategoryKey(categoryName);

  return seatrc2026Schedule.filter(
    (entry) =>
      entry.categories.includes("all") ||
      entry.categories.includes(categoryKey)
  );
};

const categorySummaries = {
  uphill: {
    date: "2026-07-24",
    location: "Cibodas",
    startTime: "15:00",
    cutOffTime: "17:00",
  },
  75: {
    date: "2026-07-25",
    location: "Cibodas",
    startTime: "01:00",
    cutOffTime: "19:00",
  },
  42: {
    date: "2026-07-25",
    location: "Cibodas",
    startTime: "04:00",
    cutOffTime: "14:00",
  },
  10: {
    date: "2026-07-26",
    location: "Cibodas",
    startTime: "06:00 (Male) / 06:10 (Female)",
    cutOffTime: "08:00 (Male) / 08:10 (Female)",
  },
};

export const getSeatrcCategorySummary = (categoryName) =>
  categorySummaries[resolveCategoryKey(categoryName)] || null;

export const groupScheduleByDate = (entries) =>
  entries.reduce((days, entry) => {
    const existingDay = days.find((day) => day.date === entry.date);
    if (existingDay) {
      existingDay.events.push(entry);
    } else {
      days.push({ date: entry.date, events: [entry] });
    }
    return days;
  }, []);
